export default __webpack_public_path__ + "static/media/UploadIMG1.be266159.svg";